import { render, staticRenderFns } from "./newsMobile.vue?vue&type=template&id=4f326059&scoped=true&"
import script from "./newsMobile.vue?vue&type=script&lang=js&"
export * from "./newsMobile.vue?vue&type=script&lang=js&"
import style0 from "./newsMobile.vue?vue&type=style&index=0&id=4f326059&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f326059",
  null
  
)

export default component.exports